<template>
  <div class="stock-linked-transport-orders stock-linked-section">
    <v-subheader class="stock-linked-section__title px-0 font-weight-bold">
      {{ title }}
    </v-subheader>
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      :items-per-page="-1"
      class="stock-linked-transport-orders__table stock-linked-table"
    >
      <template v-slot:item.code="{ item }">
        <router-link :to="{ name: 'stock-transport-orders-view', params: { id: item.id } }">
          {{ item.code }}
        </router-link>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip small :color="statusColor(item.status)" dark>
          {{ statusLabel(item.status) }}
        </v-chip>
      </template>
      <template v-slot:item.direction="{ item }">
        {{ directionLabel(item.direction) }}
      </template>
      <template v-slot:item.transport_mode="{ item }">
        {{ transportModeLabel(item.transport_mode) }}
      </template>
      <template v-slot:item.carrier="{ item }">
        {{ carrierLabel(item) }}
      </template>
      <template v-slot:item.scheduled_loading_at="{ item }">
        {{ item.scheduled_loading_at || "-" }}
      </template>
      <template v-slot:item.agreed_cost_net="{ item }">
        {{ formatMoney(item.agreed_cost_net, item.currency_code) }}
      </template>
    </v-data-table>
    <v-alert v-if="!items.length" type="info" dense text class="mt-2">
      {{ emptyMessage }}
    </v-alert>
  </div>
</template>

<script>
import stockLinkedOrderRowDisplayMixin from "@/views/partials/stock/stockLinkedOrderRowDisplay.mixin";
import { buildLinkedDocumentHeaders } from "@/views/partials/stock/stockLinkedTableHeaders";

export default {
  name: "StockLinkedTransportOrdersTable",
  mixins: [stockLinkedOrderRowDisplayMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
    emptyMessage: {
      type: String,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        ...buildLinkedDocumentHeaders(this.$t.bind(this), {
          codeLabelKey: "STOCK.TRANSPORT_ORDERS.DOCUMENT_CODE",
          counterpartyLabelKey: "STOCK.TRANSPORT_ORDERS.CARRIER",
          counterpartyValue: "carrier",
          includeWarehouse: false,
          dateLabelKey: "STOCK.TRANSPORT_ORDERS.SCHEDULED_LOADING",
          dateValue: "scheduled_loading_at",
          includeLines: false,
          totalLabelKey: "STOCK.TRANSPORT_ORDERS.AGREED_COST",
          totalValue: "agreed_cost_net",
        }),
        {
          text: this.$t("STOCK.TRANSPORT_ORDERS.DIRECTION"),
          value: "direction",
          sortable: false,
        },
        {
          text: this.$t("STOCK.TRANSPORT_ORDERS.TRANSPORT_MODE"),
          value: "transport_mode",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    carrierLabel(row) {
      const company = row.carrier_company;
      if (!company) {
        return "-";
      }
      return company.label || company.name || "-";
    },
    statusColor(status) {
      const map = {
        draft: "grey",
        sent: "blue",
        agreed: "primary",
        in_transit: "orange darken-2",
        delivered: "success",
        cancelled: "error",
      };
      return map[status] || "grey";
    },
    statusLabel(status) {
      const key = `STOCK.STATUSES.TO.${(status || "").toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : status;
    },
    directionLabel(direction) {
      const key = `STOCK.TRANSPORT_ORDERS.DIRECTIONS.${(direction || "").toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : direction;
    },
    transportModeLabel(mode) {
      const key = `STOCK.TRANSPORT_ORDERS.MODES.${(mode || "").toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : mode;
    },
    formatMoney(value, currency) {
      return this.formatOrderMoney(value, currency);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/views/partials/stock/stockLinkedTable.scss";

.stock-linked-transport-orders__table a {
  text-decoration: none;
  font-weight: 500;
}
.stock-linked-transport-orders__table a:hover {
  text-decoration: underline;
}
</style>
